/* Preview live do produto custom profession (linha pink doll).
   Porta 1:1 do compose() de scripts/barbie_name_gen.py: kerning otico por perfis
   de tinta (amostragem densa das curvas; coordenadas RELATIVAS A LINHA — o offset
   li*pitch mudava a fase dos bins e divergia entre linhas), maiusculas descem
   capDrop, texto enche targetW, estrelas fixas. Rosa #EA5BB3. */
(function () {
  var SVG_NS = "http://www.w3.org/2000/svg";
  var GARMENT = { White: "#f7f7f7", Black: "#20232a", Natural: "#f3ead9" };
  var PRINT_COLORS = {
    dark:  { pink: "rgb(234,91,179)", pale: "rgb(237,228,218)" },
    light: { pink: "rgb(234,91,179)", pale: "rgb(252,246,244)" }
  };
  var GARMENT_MODE = { White: "light", Natural: "light", Black: "dark" };

  function init(root) {
    var input = root.querySelector(".custom-name-field__input");
    var box = root.querySelector(".custom-name-preview");
    if (!input || !box) return;
    var data = null;
    var src = document.getElementById("custom-name-glyphs");
    if (src) { try { data = JSON.parse(src.textContent); } catch (e) {} }

    function currentColor() {
      var radios = document.querySelectorAll('input[type="radio"]:checked');
      for (var i = 0; i < radios.length; i++) {
        if (GARMENT[radios[i].value]) return radios[i].value;
      }
      return "White";
    }

    function pathEl(pt, palette) {
      var el = document.createElementNS(SVG_NS, "path");
      el.setAttribute("d", pt.d);
      el.setAttribute("fill", pt.fill === "pale" ? palette.pale : palette.pink);
      el.setAttribute("transform", "matrix(" + pt.m.join(",") + ")");
      return el;
    }

    function glyphPts(gl) {
      if (gl._pts) return gl._pts;
      var pts = [];
      gl.paths.forEach(function (pt) {
        if (pt.fill !== "pale") return;
        var mm = pt.m;
        function push(x, y) { pts.push([mm[0] * x + mm[2] * y + mm[4], mm[1] * x + mm[3] * y + mm[5]]); }
        var re = /([MLCZ])([^MLCZ]*)/g, seg, cur = null, start = null;
        while ((seg = re.exec(pt.d))) {
          var cmd = seg[1];
          var nums = (seg[2].match(/-?\d*\.?\d+/g) || []).map(Number);
          if (cmd === "M" && nums.length >= 2) { cur = start = [nums[0], nums[1]]; push(cur[0], cur[1]); }
          else if (cmd === "L") {
            for (var i = 0; i + 1 < nums.length; i += 2) { cur = [nums[i], nums[i + 1]]; push(cur[0], cur[1]); }
          } else if (cmd === "C") {
            for (var j = 0; j + 5 < nums.length; j += 6) {
              var p0 = cur, p1 = [nums[j], nums[j + 1]], p2 = [nums[j + 2], nums[j + 3]], p3 = [nums[j + 4], nums[j + 5]];
              for (var k = 1; k <= 6; k++) {
                var t = k / 6, mt = 1 - t;
                push(mt * mt * mt * p0[0] + 3 * mt * mt * t * p1[0] + 3 * mt * t * t * p2[0] + t * t * t * p3[0],
                     mt * mt * mt * p0[1] + 3 * mt * mt * t * p1[1] + 3 * mt * t * t * p2[1] + t * t * t * p3[1]);
              }
              cur = p3;
            }
          } else if (cmd === "Z" && start) { cur = start; }
        }
      });
      gl._pts = pts;
      return pts;
    }

    function compose(name, palette) {
      var g = data.glyphs, m = data.meta;
      var gap = m.gapFrac * m.fillCapH;
      var pitch = (m.linePitchFrac || 1.36) * m.fillCapH;
      var capDrop = (m.capDropFrac || 0) * m.fillCapH;
      var binH = m.fillCapH / (m.kernBins || 40);
      // kerning par-a-par (Fase 1): folga extra em pares de hastes estreitas coladas.
      // Igual a PAIR_KERN de barbie_name_gen.py.
      var PAIR_KERN = { ir: 0.055, rl: 0.11 };
      var pieces = [];
      name.split(/\s+/).forEach(function (word, li) {
        var line = [], prevPts = null, prevCh = null;
        for (var i = 0; i < word.length; i++) {
          var ch = word[i], gl = g[ch];
          if (!gl) continue;
          var dy = (ch === ch.toUpperCase() && ch !== ch.toLowerCase()) ? capDrop : 0;
          var tyKern = -gl.baseline + dy;
          var ty = tyKern + li * pitch;
          var raw = glyphPts(gl);
          var pts = raw.map(function (p) { return [p[0], p[1] + tyKern]; });
          var tx;
          if (prevPts === null) {
            tx = -gl.fillBbox[0];
          } else {
            var right = {}, left = {};
            prevPts.forEach(function (p) {
              var b = Math.floor(p[1] / binH);
              if (!(b in right) || p[0] > right[b]) right[b] = p[0];
            });
            pts.forEach(function (p) {
              var b = Math.floor(p[1] / binH);
              if (!(b in left) || p[0] < left[b]) left[b] = p[0];
            });
            var shift = null;
            for (var b in right) {
              if (b in left) {
                var d2 = right[b] - left[b];
                if (shift === null || d2 > shift) shift = d2;
              }
            }
            if (shift === null) {
              var maxX = -Infinity;
              prevPts.forEach(function (p) { if (p[0] > maxX) maxX = p[0]; });
              tx = maxX + gap - gl.fillBbox[0];
            } else {
              tx = shift + gap;
            }
            var pk = PAIR_KERN[prevCh + ch];
            if (pk) tx += pk * m.fillCapH;
          }
          var placed = pts.map(function (p) { return [p[0] + tx, p[1]]; });
          prevPts = prevPts === null ? placed : prevPts.concat(placed);
          line.push({ gl: gl, tx: tx, ty: ty });
          prevCh = ch;
        }
        if (!prevPts) return;
        var lx0 = Infinity, lx1 = -Infinity;
        prevPts.forEach(function (p) { if (p[0] < lx0) lx0 = p[0]; if (p[0] > lx1) lx1 = p[0]; });
        var mid = (lx0 + lx1) / 2;
        line.forEach(function (p) { p.tx -= mid; pieces.push(p); });
      });
      if (!pieces.length) return null;

      var x0 = Infinity, x1 = -Infinity, top = Infinity, bot = -Infinity;
      pieces.forEach(function (p) {
        x0 = Math.min(x0, p.gl.bbox[0] + p.tx);
        x1 = Math.max(x1, p.gl.bbox[2] + p.tx);
        top = Math.min(top, p.gl.bbox[1] + p.ty);
        bot = Math.max(bot, p.gl.bbox[3] + p.ty);
      });
      var nameW = x1 - x0, inkH = bot - top;
      var s = m.targetW / nameW;
      s = Math.min(s, m.maxFillCap / m.fillCapH);
      var stH = m.starSizes.top[1], sbH = m.starSizes.bottom[1];
      var avail = m.canvas[1] - 2 * m.vMargin - stH - sbH;
      s = Math.min(s, avail / (inkH + 2 * m.starGapFrac * m.fillCapH));
      var gapC = m.starGapFrac * m.fillCapH * s;
      var compositeH = stH + gapC + inkH * s + gapC + sbH;
      var topY = (m.canvas[1] - compositeH) / 2;
      var cx = (m.canvas[0] - nameW * s) / 2 - x0 * s;
      var cy = topY + stH + gapC - top * s;

      var svg = document.createElementNS(SVG_NS, "svg");
      svg.setAttribute("viewBox", "0 " + (topY - 80) + " 4500 " + (compositeH + 160));
      svg.setAttribute("aria-hidden", "true");

      var word = document.createElementNS(SVG_NS, "g");
      word.setAttribute("transform", "translate(" + cx + "," + cy + ") scale(" + s + ")");
      ["pink", "pale"].forEach(function (layer) {
        pieces.forEach(function (p) {
          var lg = document.createElementNS(SVG_NS, "g");
          lg.setAttribute("transform", "translate(" + p.tx + "," + p.ty + ")");
          var past = false;
          p.gl.paths.forEach(function (pt) {
            if (pt.fill === "pale") past = true;
            var take = layer === "pink" ? !past : past;
            if (!take) return;
            lg.appendChild(pathEl(pt, palette));
          });
          word.appendChild(lg);
        });
      });
      svg.appendChild(word);

      ["top", "bottom"].forEach(function (key) {
        var dims = m.starSizes[key], st = data.stars[key];
        var bw = st.bbox[2] - st.bbox[0], bh = st.bbox[3] - st.bbox[1];
        var ssx = dims[0] / bw, ssy = dims[1] / bh;
        var x = (m.canvas[0] - dims[0]) / 2;
        var y = key === "top" ? topY : topY + compositeH - sbH;
        var sg = document.createElementNS(SVG_NS, "g");
        sg.setAttribute("transform", "matrix(" + ssx + ",0,0," + ssy + "," +
          (x - st.bbox[0] * ssx) + "," + (y - st.bbox[1] * ssy) + ")");
        st.paths.forEach(function (pt) { sg.appendChild(pathEl(pt, palette)); });
        svg.appendChild(sg);
      });
      return svg;
    }

    function render() {
      if (!data) return;
      var name = (input.value || input.placeholder || "").trim();
      var color = currentColor();
      var palette = PRINT_COLORS[GARMENT_MODE[color] || "light"];
      var svg = compose(name, palette);
      box.innerHTML = "";
      box.style.background = GARMENT[color] || GARMENT.White;
      if (svg) box.appendChild(svg);
      box.classList.toggle("custom-name-preview--ghost", !input.value.trim());
    }

    render();
    input.addEventListener("input", render);
    document.addEventListener("change", function (e) {
      if (e.target && e.target.matches && e.target.matches('input[type="radio"]')) render();
    });
  }

  function boot() {
    document.querySelectorAll(".custom-name-field").forEach(init);
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else boot();
})();
